export function RepcoPurchaseOrderListCtrl (
  $uibModalInstance,
  $scope,
  $translate,
  purchase_orders,
  vendor_id
) {

  if ( angular.isString(purchase_orders) ) {
    $scope.emptyGridText = purchase_orders;
  }
  else {
    $scope.purchase_orders = purchase_orders;
  }

  $scope.vendor_id = vendor_id;

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'order_number',
        header : {
          text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_NUMBER')
        }
      },
      {
        classes: 'text-left',
        field  : 'order_date',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe   : 'globalDate'
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe   : 'globalCurrency',
      }
    ],
    empty: {
      text: $scope.emptyGridText || $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PURCHASE_ORDERS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.purchase_orders.filter(row => row.selected);
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.selectedItems = [event.row];
    $scope.add();
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.add = function () {
    $uibModalInstance.close($scope.selectedItems[0].id);
  }

  $scope.new = function () {
    $uibModalInstance.close('new');
  }
};